import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(243, 244, 251, 1)",
    color: "rgba(86, 99, 202, 1)",
    fontSize: "16px",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "rgba(19, 19, 19, 1)",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-child(1n)": { backgroundColor: "rgba(220, 222, 243, 0.1)" },
  "&:nth-child(2n)": { backgroundColor: "rgba(220, 222, 243, 0.35)" },
}));

export default function TableShows({ shows, page,total, rowsPerPage, handleChangePage }) {
  // const [agents, setAgents] = useState({});
  // const token = useSelector((state) => state.auth.token);
  // const [loadedAgents, setLoadedAgents] = useState(new Set());



  const formatDateTime = (dateString, timeString) => {
    if (!dateString || !timeString) return "Некорректные данные";

    // Парсим дату
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Неверный формат даты";

    // Парсим время из ISO-строки
    const time = new Date(timeString);
    if (isNaN(time.getTime())) return "Неверный формат времени";

    // Форматируем дату и время
    const formattedDate = date.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formattedTime = time.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // 24-часовой формат
    });

    return `${formattedTime}ч ${formattedDate.replace(/\//g, ".")}`;
  };

  return (
    <Paper sx={{ boxShadow: "none" }}>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell>Агенты</StyledTableCell>
              <StyledTableCell align="right">Время показа</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shows.length === 0 ? (
              <StyledTableRow>
                <StyledTableCell colSpan={4} align="center">
                  Нет данных
                </StyledTableCell>
              </StyledTableRow>
            ) : (
              shows
                .map((item, i) => (
                  <StyledTableRow key={i}>
                    <StyledTableCell>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        {/*{item?.base_property?.photo?.image_url ? (*/}
                        {/*    <img*/}
                        {/*        src={`${process.env.REACT_APP_API_URL}/api/v1/property${item?.base_property?.photo?.image_url}`}*/}
                        {/*        alt="property"*/}
                        {/*        style={{*/}
                        {/*          width: 70,*/}
                        {/*          height: 70,*/}
                        {/*          objectFit: "cover",*/}
                        {/*          borderRadius: "8px",*/}
                        {/*        }}*/}
                        {/*    />*/}
                        {/*) : (*/}
                        {/*    <div*/}
                        {/*        style={{*/}
                        {/*          width: 70,*/}
                        {/*          height: 70,*/}
                        {/*          backgroundColor: "#f0f0f0",*/}
                        {/*          display: "flex",*/}
                        {/*          alignItems: "center",*/}
                        {/*          justifyContent: "center",*/}
                        {/*          borderRadius: "8px",*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*      Нет фото*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        <div style={{display: "flex", flexDirection: "column"}}>
                          <span style={{
                            color: "#999",
                            fontSize: "12px",
                            marginBottom: "5px"
                          }}>ID: {item?.base_property?.id}</span>

                          <span style={{fontWeight: "600", fontSize: "14px"}}>
                            {item.base_property?.description
                                ? `${item.base_property.description.slice(0, 70)}...`
                                : "Нет описания"}
                          </span>


                        </div>
                      </div>
                    </StyledTableCell>

                    <StyledTableCell>
                      <div style={{display: "flex", alignItems: "center", gap: "12px"}}>
                        {item.agent?.photo ? (
                            <img
                                src={`${process.env.REACT_APP_API_URL}/api/v1/property/${item?.agent?.photo}`}
                                alt="property"
                                style={{
                                  width: 50,
                                  height: 50,
                                  objectFit: "cover",
                                  borderRadius: "50%",
                                }}
                            />
                        ) : (
                            <div
                                style={{
                                  width: 50,
                                  height: 50,
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                  fontSize: "8px"
                                }}
                            >
                              Нет фото
                            </div>
                        )}
                         <span>{item?.agent.name || "Нет имени"}</span>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {`${item.show_date}  ${item.show_time}` }
                    </StyledTableCell>
                  </StyledTableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {total > rowsPerPage && (
          <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={total} // Используем общее количество элементов
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
          />
      )}
    </Paper>
  );
}
